import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';

export class PolaroidGarland extends View {
  constructor(opts: ViewOpts) {
    const count = 3;
    const width = 235;
    const height = 116;
    super({
      width: width * count,
      height,
      centerOnOrigin: true,
      ...opts,
    });

    for (let i = 0; i < count; i++) {
      this.addSubview(
        new ImageScaleView({
          superview: this,
          width,
          height,
          x: i * width,
          image: 'assets/ui/family/banners/garland.png',
        }),
      );
    }
  }
}
